import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FaEdit } from "react-icons/fa";
import { MdRemoveCircle } from "react-icons/md";
import {ShowSupportAssurancesContext } from "./types";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { State } from "../../../redux/store";
import { AssuranceInterface, DefaultSupportAssuranceInterface, SupportAssuranceInterface } from "../types";
import { formatDate } from "../../../functions/functions";

const DataSupportAssurance: React.FC = () => {
  const { assurances } = useSelector((state: State) => state.assurances);
  const { AssId } = useParams()
  const {  
    showEditModal, 
    setShowEditModal,
    showDeleteModal, 
    setShowDeleteModal,
    setSelectedSupportAss
  } = useContext(ShowSupportAssurancesContext)

  const toggleEditAssurance = (support: SupportAssuranceInterface) => { 
    setShowEditModal(!showEditModal)
    setSelectedSupportAss(support)
  };

  const toggleDeleteAssurance = (support: SupportAssuranceInterface) => {
    setShowDeleteModal(!showDeleteModal)
    setSelectedSupportAss(support)
  };

  const { t } = useTranslation()

  const [supportData, setSupportData] = useState<SupportAssuranceInterface[]>([DefaultSupportAssuranceInterface])

  useEffect(() => {
    const solution: any = assurances
    ?.find((assurance: AssuranceInterface) => assurance._id === AssId)
    ?.support 
    setSupportData(solution)
  }, [assurances, AssId])

  return (
    <>
    <h1 className="text-center text-3xl mb-3">{assurances.find((assurance: AssuranceInterface) => assurance._id === AssId)?.name}</h1>
    <div className="flex flex-col border mt-3">
    <div className="overflow-x-auto">
      <div className="inline-block min-w-full sm:px-6 lg:px-8">
        <div className="overflow-hidden">
          <table className="min-w-full text-center text-sm font-light">
            <thead className="border font-medium bg-main text-white border-black ">
              <tr>
                <th className="px-4 py-4 border-r border-black">{t("Montant")}</th>
                <th className="px-4 py-4 border-r border-black">{t("Date")}</th>
                <th className="px-4 py-4 border-r border-black">{t("Actions")}</th>
              </tr>
            </thead>
            <tbody>
              {supportData?.map((support: SupportAssuranceInterface, index) =>(
                <tr className="border bg-white border-black  hover:bg-gray-200" key={index}>
                  <td className="whitespace-nowrap px-4 py-2 border-r border-black font-medium">
                    {support.amount}
                  </td>
                  <td className="whitespace-nowrap px-4 py-2 border-r border-black font-medium">
                    {formatDate(support.createdAt)}
                  </td>
                  <td className="whitespace-nowrap px-4 py-2 border-r border-black font-medium">
                    <div className="flex justify-center">
                      <FaEdit
                        className="text-second text-2xl"
                        onClick={() => toggleEditAssurance(support)}
                      />
                      <MdRemoveCircle
                        className="text-red text-2xl"
                        onClick={() => toggleDeleteAssurance(support)}
                      />
                    </div>
                  </td>
                </tr>
              ))}
              <tr className="bg-white hover:bg-gray-200">
                <td className="whitespace-nowrap px-4 py-2 font-medium border border-black ">
                  {supportData?.reduce((acc: any, currVal: SupportAssuranceInterface) => acc + currVal.amount, 0)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    </div>
    </>
  );
};

export default DataSupportAssurance;
